import { useEffect, useState } from 'react';
// Breakpoint values match those defined in theme.css
const breakpoints = {
    xs: '36rem',
    sm: '48rem',
    md: '62rem',
    lg: '75rem',
    xl: '90rem',
};
const resolveQuery = (input) => 'min' in input
    ? `(min-width: ${breakpoints[input.min]})`
    : `(max-width: calc(${breakpoints[input.max]} - 1px))`;
/**
 * Subscribes to a breakpoint media query. Returns `false` during SSR, so components must
 * treat the first client render as a correction rather than a state change.
 */
export const useMediaQuery = (input) => {
    const query = resolveQuery(input);
    const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
    useEffect(() => {
        let mounted = true;
        const mql = window.matchMedia(query);
        const handler = (e) => {
            if (mounted) {
                setMatches(e.matches);
            }
        };
        mql.addEventListener('change', handler);
        return () => {
            mounted = false;
            mql.removeEventListener('change', handler);
        };
    }, [query]);
    return matches;
};
